"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Session = exports.APIUrl = exports.APIM_KEY = exports.ApplicationName = void 0;

var common_enums_1 = require("@ryerson/common.enums/");

Object.defineProperty(exports, "ApplicationName", {
  enumerable: true,
  get: function get() {
    return common_enums_1.ApplicationName;
  }
});
exports.APIM_KEY = "ocp-apim-subscription-key";
exports.APIUrl = "/api/common/v1/public/feature-toggles/";
var Session;

(function (Session) {
  Session["features"] = "feature-toggles";
})(Session || (exports.Session = Session = {}));